import { render, staticRenderFns } from "./FilterSecond.vue?vue&type=template&id=45cc165d&scoped=true"
import script from "./FilterSecond.vue?vue&type=script&lang=js"
export * from "./FilterSecond.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cc165d",
  null
  
)

export default component.exports